export default __webpack_public_path__ + "static/media/desk.def4acdc.svg";